export default {
  CareConnect: 'CareConnect',
  Onboarding: 'Onboarding',
  Helmet: {
    title: 'Quilt: Profile',
  },
  ChatWindow: {
    Loading: 'Loading',
    InputPlaceholder: 'Type your message...',
  },
  LoadingMessage: {
    Typing: 'AI is typing...',
  },
  FormPreview: {
    Title: 'Care Overview',
  },
  YourCareBox: {
    YourCare: 'Your Care',
    CareRecipientName: 'Care Recipient Name',
    LanguagesSpoken: 'Languages Spoken',
    Location: 'Location',
    StartDate: 'Start Date',
    NamePlaceholder: 'No name provided',
    LocationPlaceholder: 'Location not specified',
    LanguagesPlaceholder: 'Languages not listed',
    StartDatePlaceholder: 'Start date to be determined',
  },
  MedicalHistoryBox: {
    Title: 'Medical History',
    Conditions: 'Conditions',
    Medications: 'Medications',
    ConditionsPlaceholder: 'No medical conditions specified',
    MedicationsPlaceholder: 'No medications listed',
  },
  CareRoutineBox: {
    Title: 'Care Routine',
    ClientRoutine: 'Client Routine',
    DailyTasks: 'Daily Tasks',
    ClientRoutinePlaceholder: 'No routine specified',
    DailyTasksPlaceholder: 'Daily tasks not outlined',
  },
  CaregiverBox: {
    Title: 'Caregiver',
    CaregiverPersonality: 'Caregiver Personality',
    Skills: 'Skills Required',
    CaregiverPersonalityPlaceholder: 'No personality preferences specified',
    SkillsPlaceholder: 'Required skills not listed',
  },
  CareScheduleBox: {
    Title: 'Care Schedule',
    Schedule: 'Schedule',
    SchedulePlaceholder: 'Care schedule to be arranged',
  },
  FamilyContactsBox: {
    Title: 'Family Contacts',
    AddContact: 'Add Contact',
    ContactsPlaceholder: 'No family contacts provided',
  },
  ContactBox: {
    ContactName: 'Contact Name',
    Relationship: 'Relationship',
    PhoneNumber: 'Phone Number',
    Email: 'Email',
    Delete: 'Delete',
  },
  TourGuide: {
    TitleStep1: 'Welcome',
    TextStep1: `Hi! I’m your CareQuilt AI—smarter than your average chatbot. I’ll guide you through
      setting up care for your loved one. Just talk to me, and I’ll handle the rest.`,
    TitleStep2: 'How It Works',
    TextStep2: `As we chat, I’ll fill in this form for you automatically. No typing, no guessing—just
      a natural conversation, and I take care of the details.`,
    TitleStep3: 'Manual Edits (If Needed)',
    TextStep3: 'Need to adjust something yourself? Just click the edit button and make changes anytime.',
    TitleStep4: 'Your Turn',
    TextStep4: 'Ready to begin? Tell me a bit about who needs care, and I’ll start shaping the perfect care plan for you.',
    TitleStepMobile: 'See Your Care Form',
    TextStepMobile: `Tap this button anytime to view or edit your loved one’s care details. 
      You can check what’s been filled in, make changes, or just see how your care plan is shaping up-all in one place.`,
    Next: 'Next',
    Skip: 'Skip Tour',
  },
  EditMode: {
    Cancel: 'Cancel',
    Save: 'Save',
  },
};
